module.exports = __webpack_public_path__ + "img/Tablet - 33.e5115289.png";